module.exports = __webpack_public_path__ + "img/rationality-h.a30715af.svg";